import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { AccordionDetailsStyle } from './styles';
import { RcAccordionDetailsClasses } from './utils';
var _RcAccordionDetails = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcAccordionDetails' });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var classes = useMemo(function () { return combineClasses(RcAccordionDetailsClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiAccordionDetails, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcAccordionDetails = styled(_RcAccordionDetails)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), AccordionDetailsStyle);
RcAccordionDetails.defaultProps = {};
RcAccordionDetails.displayName = 'RcAccordionDetails';
export { RcAccordionDetails };
var templateObject_1;
